import {useCallback} from 'react';
import useStore from '../store/store';
import {APICall} from '../api/api';
import usePersistentAuthStore from '../store/persistentAuthStore';
import usePersistentStore from '../store/persistentStore';

const useRefreshMenu = () => {
  const {auth, setAuth} = usePersistentAuthStore();

  const refreshMenu = useCallback(async () => {
    let response = await APICall({
      endpoint: 'refreshMenu',
      options: {
        method: 'POST',
        body: JSON.stringify({reportingToken: auth.reportingToken}),
        headers: {
          Authorization: `Bearer ${auth.token}`,
          'Content-Type': 'application/json',
        },
      },
    });

    if (response.success) {
      // Override auth object with updated menu and token
      // Token has publishers and domains, so we need to update it as well
      const current = usePersistentAuthStore.getState().auth;
      const keepSignedIn = usePersistentStore.getState().keepSignedIn !== false;
      setAuth({
        ...current,
        token: response.token,
        refreshToken: keepSignedIn ? response.refreshToken || current.refreshToken : undefined,
        menu: response.menu,
      });
    }
  }, [auth, setAuth]);

  return {refreshMenu};
};

export default useRefreshMenu;
